import {ReactElement} from "react";
import {Spinner} from "@zendeskgarden/react-loaders";
import {Check} from "@material-ui/icons";
import {COLORS} from "../../../../constants/Colors";
import css from "../styles/vz-thinking.module.scss";
import {VZThinkingStepStatus} from "../useVZThinkingRunner";


export interface VZThinkingStatusIconProps {
    status: VZThinkingStepStatus;
}

export default function VZThinkingStatusIcon(props: VZThinkingStatusIconProps): ReactElement {
    if (props.status === "active") {
        return (
            <span className={css.statusIcon}>
                <Spinner size="20" color={COLORS.PRIMARY_500} delayMS={200} />
            </span>
        );
    }

    if (props.status === "complete") {
        return (
            <span className={`${css.statusIcon} ${css.statusIconComplete}`}>
                <Check className={css.checkIcon} />
            </span>
        );
    }

    return <span className={css.statusIcon} />;
}
